export const BUTTON_SIZE = 32;
export const BUTTON_SIZE_NATIVE = 24;
export const ACTION_BAR_HEIGHT = 40;